import React from 'react';
import { TERMS_URL, PRIVACY_URL } from '../constants/legalLinks';

/**
 * TermsPrivacyConsent — inline consent notice displayed beneath the primary
 * CTA (sign-in or account setup button) on authentication pages.
 *
 * Renders the standard "By continuing, you agree to our Terms of Service and
 * Privacy Policy" pattern used across the industry. Links open in a new tab
 * so users can review the documents without losing their place in the flow.
 *
 * Used on:
 *   - ClinicianSignUp (provider sign-in)
 *   - PatientSignUp (service user sign-in)
 *   - SetUpPassword (provider initial account setup)
 *   - PatientSetUpPassword (service user initial account setup)
 */
export default function TermsPrivacyConsent() {
  return (
    <p className="text-xs text-center text-gray-400 mt-1 mb-2">
      By continuing, you agree to our{' '}
      <a
        href={TERMS_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="underline hover:text-gray-600 transition-colors"
      >
        Terms of Service
      </a>
      {' '}and{' '}
      <a
        href={PRIVACY_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="underline hover:text-gray-600 transition-colors"
      >
        Privacy Policy
      </a>
      .
    </p>
  );
}
